import axios from 'axios'

const api = axios.create({
  baseURL: 'https://api.cinchbudget.com'
})
import { useAuth0 } from '@auth0/auth0-vue'

export const setupAuthInterceptor = () => {
  const { idTokenClaims } = useAuth0()
  api.interceptors.request.use(
    async (config) => {
      try {
        const token = idTokenClaims.value?.__raw
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      } catch (error) {
        console.error('Failed to get ID token:', error)
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

export const reportError = async (error, doAlert = true) => {
  try {
    await api.post('/SystemMaintenance/ReportError', {
      application: 'CinchBudget Payments Web',
      agent: navigator.userAgent,
      description: JSON.stringify(error, null, 2),
      timestamp: new Date().toISOString()
    })
    if (doAlert)
      alert('An unexpected error occurred. Please try again later.')
  } catch (reportingError) {
    console.error('Failed to report error:', reportingError)
  }
}

export const createTier2PaymentSession = async () => {
  try {
    const response = await api.post('/Tier2PaymentSession')
    return response.data
  } catch (error) {
    if (error.response?.status === 400)
      alert(error.response.data)
    if (error.response?.data)
      error.message = `${error.message} - Response: ${error.response.data}`
    throw error
  }
}

export const getSubscriptions = async () => {
  const response = await api.get('/subscriptions')
  return response.data.subscriptions && response.data.subscriptions[0]
}

export const deleteSubscription = async () => {
  await api.delete('/subscriptions')
}

export const getPaymentSession = async (sessionId) => {
  const response = await api.get(`/tier2paymentsession/${sessionId}`)
  return response.data
}

export default api